import axios from "axios";

export const getAllInstructManual = async () => {
  try {
    const token = getToken();
    // console.log("JWT token:", token);

    const response = await axios.get(
      `${process.env.REACT_APP_URL}${process.env.REACT_APP_PORT}/api/Upload/files`,
      {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      }
    );
    console.log("filesResponse ", response);
    if (!response.status || response.status >= 400) {
      throw new Error(
        `Failed to fetch files: ${response.status} ${response.statusText}`
      );
    }
    return response;
  } catch (error) {
    console.error("Error fetching files:", error);
    return error.message || "Не вдалося завантажити файли";
  }
};

export const loadFilesContent = (file) => {
  console.log("file ", file);
  let fileUrl;
  if (file.type === "instruction") {
    fileUrl = `${process.env.REACT_APP_URL}${
      process.env.REACT_APP_PORT
    }/instructions_folder/${encodeURIComponent(file.file)}`;
  } else if (file.type === "manual") {
    fileUrl = `${process.env.REACT_APP_URL}${
      process.env.REACT_APP_PORT
    }/manuals_folder/${encodeURIComponent(file.file)}`;
  } else {
    console.log("Файл не знайдено!");
    return "Файл не знайдено!";
  }

  return {
    uri: fileUrl,
    fileType: "pdf",
    timestamp: Date.now(),
    customName: file.name,
  };
};

export const deleteOneFile = async (id) => {
  try {
    const token = getToken();
    const apiUrl = `${process.env.REACT_APP_URL}${process.env.REACT_APP_PORT}/api/Upload/deletefiles/${id}`;
    console.log("Deleting file with URL:", apiUrl);

    const response = await axios.delete(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
    });

    console.log("Delete response:", response);
    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    console.error("Error deleting file:", error);
    console.log("Error details:", {
      message: error.message,
      response: error.response
        ? {
            status: error.response.status,
            data: error.response.data,
            headers: error.response.headers,
          }
        : "No response",
    });
    return error.message || "Не вдалося видалити файл";
  }
};

export const editOneFile = async (updatedFile) => {
  try {
    const token = getToken();
    const apiUrl = `${process.env.REACT_APP_URL}${process.env.REACT_APP_PORT}/api/Upload/editfile/${updatedFile.id}`;
    console.log("Editing file with URL:", apiUrl, "Data:", updatedFile);

    const response = await axios.put(apiUrl, updatedFile, {
      headers: { Authorization: `Bearer ${token}` },
    });
    console.log("Edit response:", response.data);
    return response;
  } catch (error) {
    console.error("Error editing file:", error);
    console.log("Error details:", {
      message: error.message,
      response: error.response
        ? {
            status: error.response.status,
            data: error.response.data,
            headers: error.response.headers,
          }
        : "No response",
    });
    return error.message || "Не вдалося редагувати файл";
  }
};

export const addOneFile = async (formData) => {
  try {
    const token = getToken();
    const response = await fetch(
      `${process.env.REACT_APP_URL}${process.env.REACT_APP_PORT}/api/Upload/upload`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      }
    );
    console.log("Response add ", response);
    // if (!response.ok) {
    //   const errorData = await response.json();
    //   throw new Error(errorData.error || "Помилка завантаження файлу");
    // }

    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    return error.message || "Не вдалося додати файл";
  }
};

const getToken = () => {
  const token = localStorage.getItem("SERVICE_TOKEN");
  console.log("Get Token:", token);
  if (token) return token;
};
